import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconEditProps extends SVGProps<any> {}
export class SVGIconEdit extends Component<SVGIconEditProps> {
  render() {
    const { width = 25, height = 25, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-edit"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 33 33`}
        {...rest}
      >
        <g filter="url(#filter0_d_3193_124)">
          <path
            d="M27.8923 1.10829C27.1815 0.398606 26.2181 0 25.2137 0C24.2093 0 23.246 0.398606 22.5352 1.10829L5.53164 18.1122C5.04471 18.5964 4.65863 19.1724 4.39573 19.8068C4.13283 20.4412 3.99833 21.1214 4.00002 21.8081V23.9545C4.00002 24.2318 4.11016 24.4977 4.30623 24.6938C4.50229 24.8898 4.76821 25 5.04549 25H7.19185C7.87848 25.0019 8.55867 24.8676 9.19305 24.6049C9.82743 24.3422 10.4034 23.9562 10.8876 23.4694L27.8923 6.46437C28.6016 5.75364 29 4.7905 29 3.78633C29 2.78217 28.6016 1.81903 27.8923 1.10829ZM9.4093 21.991C8.81966 22.5768 8.02296 22.9066 7.19185 22.909H6.09097V21.8081C6.08991 21.3961 6.17058 20.9879 6.32833 20.6073C6.48607 20.2266 6.71774 19.8811 7.00994 19.5906L19.9142 6.68602L22.3188 9.09066L9.4093 21.991ZM26.4129 4.98604L23.7929 7.6071L21.3884 5.20768L24.0094 2.58662C24.1672 2.42908 24.3546 2.30417 24.5608 2.21904C24.7669 2.1339 24.9878 2.09021 25.2109 2.09045C25.4339 2.0907 25.6547 2.13487 25.8607 2.22045C26.0667 2.30603 26.2538 2.43135 26.4113 2.58924C26.5689 2.74713 26.6938 2.93451 26.7789 3.14067C26.8641 3.34683 26.9077 3.56774 26.9075 3.79079C26.9073 4.01384 26.8631 4.23466 26.7775 4.44064C26.6919 4.64661 26.5666 4.83372 26.4087 4.99127L26.4129 4.98604Z"
            fill="#364856"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3193_124"
            x="0"
            y="0"
            width="33"
            height="33"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3193_124"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3193_124"
              result="shape"
            />
          </filter>
        </defs>
      </SVG>
    );
  }
}
